<template>
  <span class="n-text"><slot></slot></span>
</template>

<script>
export default {
  name: 'NText',
};
</script>
